export default __webpack_public_path__ + "static/SpectrumMOAefla_peg_r2-d34bd2b4b99c2295aa03dc438b623453.png";